import PropTypes from 'prop-types';

export default function ArrowForwardIcon(props) {
  const { color = "currentColor", className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="none"
      viewBox="0 0 30 30"
      className={className}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M12.683 19.192a.625.625 0 010-.884L15.991 15l-3.308-3.308a.625.625 0 11.884-.884l3.75 3.75a.625.625 0 010 .884l-3.75 3.75a.625.625 0 01-.884 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

ArrowForwardIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
}